import { getCycles } from './GetCycles';
import { getCycle } from './GetCycle';
import { createCycle } from './CreateCycle';
import { updateCycle } from './UpdateCycle';
import { getCycleMemberships } from './GetCycleMemberships';
import { getUserCycles } from './GetUserCycles';
import { updateMembershipStatus } from './UpdateMembershipStatus';
import { uploadMembershipsCsv } from './UploadMembershipsCsv';
import { downloadCycleExport } from './DownloadCycleExport';

export const AwardsApi = {
  getCycles,
  getCycle,
  createCycle,
  updateCycle,
  getCycleMemberships,
  getUserCycles,
  updateMembershipStatus,
  uploadMembershipsCsv,
  downloadCycleExport,
};
